module.exports = __webpack_public_path__ + "img/13.785ad469.webp";